import { fromJS, List } from 'immutable';

import TeamMemberModel from 'models/TeamMemberModel';

import { createReducer } from '../utils/helpers';

import { companyUsers } from './types';

export * from './actions';

const initialState = fromJS({
  byId: {},
  users: {
    // [entityId]: {
    //     data: [],
    //     network: { loading: false, error: false }
    // },
  },
});

export default createReducer(initialState, {
  [companyUsers.request]: (state, action) =>
    state.setIn(['users', action.entityId, 'network', 'loading'], true),
  [companyUsers.success]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['users', action.entityId, 'network', 'loading'], false)
        .setIn(['users', action.entityId, 'network', 'error'], false)
        .setIn(
          ['users', action.entityId, 'data'],
          List(action.response.map((user) => TeamMemberModel.deserialize(user))),
        ),
    ),
  [companyUsers.failure]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['users', action.entityId, 'network', 'loading'], false)
        .setIn(['users', action.entityId, 'network', 'error'], action.error),
    ),
});
